import { render, staticRenderFns } from "./modalActualizarDatos.vue?vue&type=template&id=5cf07ee0&scoped=true&"
import script from "./modalActualizarDatos.vue?vue&type=script&lang=js&"
export * from "./modalActualizarDatos.vue?vue&type=script&lang=js&"
import style0 from "./modalActualizarDatos.vue?vue&type=style&index=0&id=5cf07ee0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf07ee0",
  null
  
)

export default component.exports